<template>
<div class="bg-gray w-full pr-5 px-3  py-4 text-sm mb-4" v-if="!emptyRates">
  <div class="w-full text-center font-bold mr-2 cursor-pointer sm:hidden lg:hidden xl:hidden md:hidden"
       @click="hideCurrency = !hideCurrency">
    {{ $t('message.menu.currencyRate') }} {{ currencyRateDate }}
  </div>
  <div class="w-full text-center font-bold sm:block md:block lg:block xl:block hidden"
       @click="hideCurrency = true">
    {{ $t('message.menu.currencyRate') }} {{ currencyRateDate }}
  </div>
  <div class="sm:block md:block lg:block xl:block" :class="{'hidden': hideCurrency}">
    <div class="w-full flex">
      <div class="w-2/5"></div>
      <div class="w-1/5"></div>
      <div class="w-1/4 text-center pl-2">{{ $t('message.menu.currencyByu') }}</div>
      <div class="w-1/4 text-center">{{ $t('message.menu.currencySell') }}</div>
    </div>
    <vs-divider class="m-0 p-0" />
    <div :key="key" v-for="(rate, key) in currencyRate" class="w-full">
      <vs-divider class="m-0 p-0" v-if="rate.type.length > 0 && key > 0"></vs-divider>
      <div class="w-1/3 inline-block px-2">
        <p class="text-xs text-center bg-primary text-white rounded-full">
          {{ rate.type }}
        </p>
      </div>
      <div class="w-1/5 inline-block text-center font-bold">{{ rate.currency_code }}</div>
      <template v-if="rate.typeId > 0">
        <div class="w-1/4 inline-block text-center">{{ rate.value_buy }}</div>
        <div class="w-1/4 inline-block text-center">{{ rate.value_sell }}</div>
      </template>
      <template v-if="rate.typeId === 0">
        <div class="w-1/2 inline-block text-center">{{ rate.value_sell }}</div>
      </template>
    </div>
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'CurrencyRates',
  methods: {
    ...mapActions('utils', ['fetchCurrencyRates'])
  },
  data: () => ({
    hideCurrency: true
  }),
  computed: {
    ...mapGetters('utils', ['getCurrencyRate', 'emptyRates']),
    currencyRate () {
      const rates = []
      let oldType = -1

      for (const key in this.getCurrencyRate) {

        const date = new Date(this.getCurrencyRate[key].rate_begin)
        //const fixed = this.getCurrencyRate[key].currency_code !== 'RUB' ? 2 : 4
        const fixed = 4
        if (this.getCurrencyRate[key].currency_code === 'TJS') continue
        rates.push({
          type: oldType !== this.getCurrencyRate[key].type ? this.$tc('message.menu.currency', this.getCurrencyRate[key].type) : '',
          typeId: this.getCurrencyRate[key].type,
          currency_code: this.getCurrencyRate[key].currency_code,
          rate_begin: `${(`0${date.getDate()}`).slice(-2)}.${(`0${date.getMonth() + 1}`).slice(-2)}.${date.getFullYear()}`,
          value_buy: parseFloat(this.getCurrencyRate[key].value_buy).toFixed(fixed),
          value_buy_delta: parseFloat(this.getCurrencyRate[key].value_delta_buy).toFixed(fixed),
          value_sell: parseFloat(this.getCurrencyRate[key].value_sell).toFixed(fixed),
          value_sell_delta: parseFloat(this.getCurrencyRate[key].value_delta_sell).toFixed(fixed)
        })
        oldType = this.getCurrencyRate[key].type
      }

      return rates
    },
    themePrimaryColor () {
      return this.$store.state.themePrimaryColor
    },
    currencyRateDate () {
      let start = '00.00.0000'
      for (const i in this.currencyRate) {
        if (start < this.currencyRate[i].rate_begin) start = this.currencyRate[i].rate_begin
      }
      const date = new Date()
      return `${(`0${date.getDate()}`).slice(-2)}.${(`0${date.getMonth() + 1}`).slice(-2)}.${date.getFullYear()}`
      //return start
    }
  }
}
</script>

<style scoped>

</style>
